import {useEffect, useMemo} from "react";
import {useSelector} from "react-redux";
import {selectorAudioCurrentTime, selectorAudioIsAutoScroll, selectorAudioIsPlaying} from "../reducers/AudioSlice";
import {useHistory, useLocation, useParams} from "react-router-dom";
import {CreateLinkTo} from "../../../constants/linkTo";

const getAdditionalInfoVal = (additionalInfo: any, key: any) => {
    if (additionalInfo?.length === 0 || !additionalInfo) return null
    return additionalInfo?.find((i:any) => i?.name === key)?.value || null
}

const parseTime = (time: string) => {

    const values = time.split(':')
    if (values?.length < 3) return 0

    return parseInt(values[0]) * 3600 + parseInt(values[1]) * 60 + parseInt(values[2])
}

const parseLink = (link: string) => {

    if (!link) return {
        projectId: '',
        hash: ''
    }
    const urlParts = link.split('/')
    if (urlParts?.length === 0) return {
        projectId: '',
        hash: ''
    }
    const urlIdPart = urlParts[urlParts.length - 1].split('#')

    return {
        projectId: urlIdPart?.length >= 1 ? urlIdPart[0] : '',
        hash: urlIdPart?.length >= 2 ? urlIdPart[1] : ''
    }
}

export const parseUrlProjectId = (pathname: string) => {

    if (!pathname) return ''
    const urlParts = pathname.split('/')
    if (urlParts?.length < 3) return ''
    if (urlParts[1] !== 'project') return ''
    return urlParts[2] || ''
}

export const useTimecodesListener = (post: any) => {

    const podcastTimeCodes = useMemo(() => JSON.parse(getAdditionalInfoVal(post?.additionalInfo || [], 'podcastTimeCodes') || "[]"), [post?.additionalInfo]);
    const currentTime = useSelector(selectorAudioCurrentTime)
    const roundedCurrentTime = useMemo(() => Math.floor(currentTime), [currentTime])
    const isPlaying = useSelector(selectorAudioIsPlaying)
    const isAutoScroll = useSelector(selectorAudioIsAutoScroll)
    const history = useHistory()
    const location = useLocation()
    const urlProjectId = useMemo(() => parseUrlProjectId(location.pathname), [location.pathname])
    const formattedPodcastTimeCodes = useMemo(() => podcastTimeCodes.map((timeCode: any) => {
        return {
            ...timeCode,
            time: parseTime(timeCode?.time || ''),
            link: parseLink(timeCode?.link || '')
        }
    }), [podcastTimeCodes])

    useEffect(() => {

        if (!isAutoScroll || !isPlaying) return;

        const activeTimeCode = formattedPodcastTimeCodes?.find((timeCode: any) => timeCode?.time === roundedCurrentTime)

        if (activeTimeCode && activeTimeCode?.link?.projectId && activeTimeCode?.link?.hash) {

            const link = CreateLinkTo.project(activeTimeCode?.link?.projectId) + '#' + activeTimeCode?.link?.hash;
            if (urlProjectId !== activeTimeCode?.link?.projectId) {
                if (urlProjectId) history.replace(location.pathname)
                history.push(link)
            } else history.replace(link)
        }

    }, [formattedPodcastTimeCodes, roundedCurrentTime, isAutoScroll, isPlaying, urlProjectId, location.pathname])
}import {useEffect, useMemo} from "react";
import {useSelector} from "react-redux";
import {selectorAudioCurrentTime, selectorAudioIsAutoScroll, selectorAudioIsPlaying} from "../reducers/AudioSlice";
import {useHistory, useLocation, useParams} from "react-router-dom";
import {CreateLinkTo} from "../../../constants/linkTo";

const getAdditionalInfoVal = (additionalInfo: any, key: any) => {
    if (additionalInfo?.length === 0 || !additionalInfo) return null
    return additionalInfo?.find((i:any) => i?.name === key)?.value || null
}

const parseTime = (time: string) => {

    const values = time.split(':')
    if (values?.length < 3) return 0

    return parseInt(values[0]) * 3600 + parseInt(values[1]) * 60 + parseInt(values[2])
}

const parseLink = (link: string) => {

    if (!link) return {
        projectId: '',
        hash: ''
    }
    const urlParts = link.split('/')
    if (urlParts?.length === 0) return {
        projectId: '',
        hash: ''
    }
    const urlIdPart = urlParts[urlParts.length - 1].split('#')

    return {
        projectId: urlIdPart?.length >= 1 ? urlIdPart[0] : '',
        hash: urlIdPart?.length >= 2 ? urlIdPart[1] : ''
    }
}

export const parseUrlProjectId = (pathname: string) => {

    if (!pathname) return ''
    const urlParts = pathname.split('/')
    if (urlParts?.length < 3) return ''
    if (urlParts[1] !== 'project') return ''
    return urlParts[2] || ''
}

export const useTimecodesListener = (post: any) => {

    const podcastTimeCodes = useMemo(() => JSON.parse(getAdditionalInfoVal(post?.additionalInfo || [], 'podcastTimeCodes') || "[]"), [post?.additionalInfo]);
    const currentTime = useSelector(selectorAudioCurrentTime)
    const roundedCurrentTime = useMemo(() => Math.floor(currentTime), [currentTime])
    const isPlaying = useSelector(selectorAudioIsPlaying)
    const isAutoScroll = useSelector(selectorAudioIsAutoScroll)
    const history = useHistory()
    const location = useLocation()
    const urlProjectId = useMemo(() => parseUrlProjectId(location.pathname), [location.pathname])
    const formattedPodcastTimeCodes = useMemo(() => podcastTimeCodes.map((timeCode: any) => {
        return {
            ...timeCode,
            time: parseTime(timeCode?.time || ''),
            link: parseLink(timeCode?.link || '')
        }
    }), [podcastTimeCodes])

    useEffect(() => {

        if (!isAutoScroll || !isPlaying) return;

        const activeTimeCode = formattedPodcastTimeCodes?.find((timeCode: any) => timeCode?.time === roundedCurrentTime)

        if (activeTimeCode && activeTimeCode?.link?.projectId && activeTimeCode?.link?.hash) {

            const link = CreateLinkTo.project(activeTimeCode?.link?.projectId) + '#' + activeTimeCode?.link?.hash;
            if (urlProjectId !== activeTimeCode?.link?.projectId) {
                if (urlProjectId) history.replace(location.pathname)
                history.push(link)
            } else history.replace(link)
        }

    }, [formattedPodcastTimeCodes, roundedCurrentTime, isAutoScroll, isPlaying, urlProjectId, location.pathname])
}